import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(6),
        top: theme.spacing(3.5),
        color: theme.palette.grey[500],
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxSizing: 'border-box',
        borderRadius: 0,
        boxShadow: 'none',
        maxWidth: '480px',
        '& h4': {
            fontSize: theme.typography.pxToRem(18),
        },
        '& p,button': {
            fontSize: theme.typography.pxToRem(18),
            [theme.breakpoints.down('xs')]: {
                fontSize: theme.typography.pxToRem(16),
                marginBottom: '10px!important',
            },
        },
        '& .MuiDialogContent-root:focus': {
            outline: 'none',
        },
        [theme.breakpoints.down('xs')]: {
            margin: 20,
        },
    },
    dialogTitle: {
        padding: theme.spacing(3, 3, 1, 3),
        '& a': {
            marginRight: 24,
        },
    },
    dialogTitleEmpty: {
        padding: theme.spacing(3, 3, 5, 3),
        '& a': {
            marginRight: 24,
        },
    },
    backDropOverlay: {
        backgroundColor: `rgba(19, 25, 71, 0.2)!important`,
    },
    dialogContent: {
        paddingBottom: 24,
        fontWeight: 300,
        '& input[type="text"]': {
            backgroundColor: '#f7f8f7',
        },
    },
    dialogAction: {
        padding: theme.spacing(3, 3, 0, 3),
    },
}));
